'use client'

import { useEffect, useState } from 'react'

import { ChevronUp } from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * BackToTopButton is a floating button that appears after scrolling down.
 * Smoothly scrolls the user back to the top of the page.
 */
export function BackToTopButton() {
    const [isVisible, setIsVisible] = useState(false)

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.scrollY > 500)
        }

        window.addEventListener('scroll', toggleVisibility)
        return () => {
            window.removeEventListener('scroll', toggleVisibility)
        }
    }, [])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    return (
        <button
            className={cn(
                'fixed right-5 bottom-5 z-50 flex h-[60px] w-[60px] cursor-pointer items-center justify-center rounded-full bg-[#878787] text-white transition-opacity duration-200 hover:opacity-80 md:bottom-1/2',
                isVisible ? 'opacity-50' : 'pointer-events-none opacity-0',
            )}
            onClick={scrollToTop}
            aria-label="Back to top"
        >
            <ChevronUp className="h-5 w-5" />
        </button>
    )
}
